//LOGIN USER
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGIN_CLEAR_STATE = 'USER_LOGIN_CLEAR_STATE';

//USER ROLE

export const USER_ROLE_REQUEST = 'USER_ROLE_REQUEST';
export const USER_ROLE_SUCCESS = 'USER_ROLE_SUCCESS';
export const USER_ROLE_FAIL = 'USER_ROLE_FAIL';

export const USER_TOKEN = 'USER_TOKEN'
export const SET_SESSION_ID = 'SET_SESSION_ID';
export const DECODED_TOKEN = 'DECODED_TOKEN';